import React from 'react';
import {connect} from 'react-redux';
// Components
import Anchor from 'Components/lto/common/Anchor';
import ProductImage from 'Components/lto/commonOrder/ProductImage';
import BasicButton from 'Components/lto/common/BasicButton';
import {NavigateNext, InfoOutlined} from '@material-ui/icons';
import Button from '@material-ui/core/Button';
import copy from 'copy-to-clipboard';
import {customerConfirmLink} from 'Utils/urlUtil';
import {openNotification} from 'Actions/notification';

// Actions
import {T} from 'Actions/translate';
import util from 'Utils/commonUtil';

// Icons
import {AccessTime} from '@material-ui/icons';

class LtoPurchaesOrderHistoryItem extends React.Component {
    state = {
        readID: null,
    };

    getOrderStatus = (item) => {
        let statusLabel = '';
        if (item.orderStatus === 'To_Be_Confirmed') {
            statusLabel = item.retentionTime
                ? item.retentionTime.substring(
                      item.retentionTime.indexOf('-') + 1,
                  )
                : '';
        } else if (item.orderStatus === 'Confirmed') {
            statusLabel = item.confirmedTime;
        }
        return statusLabel;
    };

    gotoMyOrderList = (salesOrderNumber, e) => {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        } else {
            window.e.cancelBubble = true;
        }
        this.props.gotoMyOrderList(salesOrderNumber);
    };

    phoneClick = (e) => {
        e.stopPropagation();
    };

    resendNotification = (item, e) => {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        } else {
            window.e.cancelBubble = true;
        }

        console.log(item);
        this.props.gotoResendNotification(item);
    };

    cancelOrder = (item, e) => {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        } else {
            window.e.cancelBubble = true;
        }

        console.log(item);
        this.props.openCancelOrderDialog(item);
    };

    phoneClick = (e) => {
        e.stopPropagation();
    };

    copyToClipBoard = (item, e) => {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        } else {
            window.e.cancelBubble = true;
        }
        copy(`${customerConfirmLink}${item.number} `);
        this.props.openNotification(T('notification_copy_success'), 'success');
    };

    showCustomerCopyLinkMessage = (e) => {
        if (e && e.stopPropagation) {
            e.stopPropagation();
        } else {
            window.e.cancelBubble = true;
        }
        this.props.openNotification(
            T(
                'lto_purchase_order_copy_confirmation_link_to_customer_confirm_lto',
            ),
            'danger',
        );
    };

    render() {
        const {item} = this.props;
        return (
            <Anchor
                className="order_history_item"
                onClickOfSingleTap={this.props.chooseItem}>
                <div
                    testid="preorder-history-card"
                    data-preorder-number={item.number}
                    data-order-status={item.orderStatus}>
                    <div className="first-row">
                        <div className="first-column">
                            {item.orderStatus === 'Confirmed' &&
                            item.eoneOrderList &&
                            item.eoneOrderList.length > 0 ? (
                                <div className="eone-order-list">
                                    <ul>
                                        {item.eoneOrderList.map(
                                            (eoneItem, eoneInde) => (
                                                <li key={eoneInde}>
                                                    <div className="eone-order-type">
                                                        {eoneItem.orderType}
                                                    </div>
                                                    <div
                                                        className="sales-order-number"
                                                        onClick={(event) =>
                                                            this.gotoMyOrderList(
                                                                eoneItem.salesOrderNumber,
                                                                event,
                                                            )
                                                        }
                                                        onTouchStart={
                                                            this.phoneClick
                                                        }>
                                                        {
                                                            eoneItem.salesOrderNumber
                                                        }
                                                    </div>
                                                </li>
                                            ),
                                        )}
                                    </ul>
                                </div>
                            ) : (
                                <label>{item.number}</label>
                            )}
                        </div>
                        <div className="second-column">
                            {item.orderStatus === 'To_Be_Confirmed' && (
                                <div className="clock-icon">
                                    <AccessTime />
                                </div>
                            )}
                            {item.orderStatus === 'Confirmed' && (
                                <div className="clock-icon">
                                    {T('lto_history_detail_confirm_time')}
                                </div>
                            )}
                            <div
                                className={
                                    item.orderStatus === 'Cancelled'
                                        ? 'expiry-time cancel-data'
                                        : 'expiry-time'
                                }>
                                {item.orderStatus === 'Cancelled' ? (
                                    <div>
                                        {T(
                                            util.showCancelledOrderStatus(
                                                item.cancelBy,
                                            ),
                                        )}
                                    </div>
                                ) : (
                                    <div>
                                        {this.getOrderStatus(item)}
                                        {item.orderStatus ===
                                            'To_Be_Confirmed' && (
                                            <label>
                                                {T(
                                                    'lto_history_detail_24_hour_expiration',
                                                )}
                                            </label>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="item-normal">
                        <div className="left">
                            {T('lto_history_list_st_name')}
                        </div>
                        <div className="right">{item.stAlpha}</div>
                    </div>

                    <div className="item-double-normal second-row">
                        <div className="left">
                            <div className="content-left">
                                {T('lto_history_list_st_number')}
                            </div>
                            <div className="content-right">
                                {item.shipToNumber}
                            </div>
                        </div>
                        <div className="right">
                            <div class="content-left">
                                {T('lto_history_list_submit_time')}
                            </div>
                            <div class="content-right">{item.createTime}</div>
                        </div>
                    </div>

                    <div className="item-normal">
                        <div className="left">
                            {T('lto_history_list_customer_account')}
                        </div>
                        <div className="right">{item.customerEmail}</div>
                    </div>

                    <div className="item-normal">
                        <div className="left">
                            {T('lto_history_list_recipient')}
                        </div>
                        <div className="right">
                            {item.receiver + ' '} {item.receiverTel}
                        </div>
                    </div>

                    <div className={'item-double-normal'}>
                        <div className="left">
                            <div className="content-left">
                                {T('lto_history_list_po_number')}
                            </div>
                            <div className="content-right">
                                {item.poNumber ? item.poNumber : T('-')}
                            </div>
                        </div>
                    </div>

                    {item.orderStatus === 'To_Be_Confirmed' && (
                        <div className="item-normal">
                            <div className="left copy-link-item">
                                {T(
                                    'lto_purchase_order_customer_confirmation_link',
                                )}
                                <InfoOutlined
                                    onTouchStart={this.phoneClick}
                                    onClick={(event) =>
                                        this.showCustomerCopyLinkMessage(event)
                                    }
                                />
                                <Button
                                    className="copy-confirm-btn"
                                    type="primary"
                                    disabled={false}
                                    onTouchStart={this.phoneClick}
                                    onClick={(event) =>
                                        this.copyToClipBoard(item, event)
                                    }>
                                    {T(
                                        'lto_purchase_order_copy_confirmation_link',
                                    )}
                                </Button>
                            </div>
                        </div>
                    )}

                    {/* <div className="sku-box">
                        <div class="box-left">
                            {item.orderProducts && item.orderProducts.length > 0
                                ? item.orderProducts.map(
                                      (productItem, index) => (
                                          <div class="skuItem">
                                              {productItem.sku}
                                          </div>
                                      ),
                                  )
                                : null}
                        </div>
                        {item.orderProducts && item.orderProducts.length > 0 ? (
                            <div class="box-right">
                                <div class="gray-text">
                                    {T('lto_history_list_total_sku', [
                                        item.orderProducts.length,
                                    ])}
                                </div>
                            </div>
                        ) : null}
                    </div> */}

                    <section className="my-order-detail">
                        <p className="image-list">
                            {item.orderProducts &&
                                item.orderProducts.map((p, index) => {
                                    if (index > 3) return null;

                                    return (
                                        <div
                                            className="sku-and-image"
                                            key={p.id}>
                                            <ProductImage
                                                src={
                                                    p.productImage
                                                        ? p.productImage +
                                                          '-250.jpg'
                                                        : ''
                                                }
                                                key={p.productImage}
                                                alt={p.productName}
                                            />
                                            <div class="my-order-sku">
                                                {p.sku}
                                            </div>
                                        </div>
                                    );
                                })}
                        </p>
                        <p className="quantity desc">
                            {T('lto_history_list_total_sku', [
                                item.orderProducts.length,
                            ])}
                            <NavigateNext />
                        </p>
                    </section>

                    <div className="item-normal order-total-price">
                        <div className="first-column">
                            <div class="left">
                                {T('lto_history_list_order_total_price')}
                            </div>
                            <div class="right totalPrice">
                                {T('¥')}{' '}
                                {item.orderProducts ? item.totalPrice : ''}
                            </div>
                        </div>

                        {item.orderStatus === 'To_Be_Confirmed' && (
                            <div
                                className="second-column"
                                onTouchStart={this.phoneClick}>
                                <BasicButton
                                    className="resend-cancel-btn"
                                    testid="preorder-history-cancel-notification-btn"
                                    type="primary"
                                    disabled={false}
                                    onClickOfSingleTap={(event) =>
                                        this.cancelOrder(item, event)
                                    }>
                                    {T('lto_history_list_cancel_notification')}
                                </BasicButton>
                                <BasicButton
                                    className="resend-confirm-btn"
                                    testid="preorder-history-resend-notification-btn"
                                    type="primary"
                                    disabled={false}
                                    onClickOfSingleTap={(event) =>
                                        this.resendNotification(item, event)
                                    }>
                                    {T('lto_history_list_notification')}
                                </BasicButton>
                            </div>
                        )}
                    </div>
                </div>
            </Anchor>
        );
    }
}

const mapStateToProps = (state) => {
    const {localData} = state;
    return {
        localData,
    };
};

const mapDispatchToProps = {
    openNotification,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(LtoPurchaesOrderHistoryItem);
